/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgPageContent = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M10 17H8v-2h2zm6 0h-4v-2h4zm-6-4H8v-2h2zm6 0h-4v-2h4zm-5-4H8V7h3z" />
        <path d="M20 7.586V22H4V2h10.414zM6 20h12V9h-5V4H6zm9-13h1.586L15 5.414z" />
      </g>
    </g>
  </Icon>
);
export { SvgPageContent as PageContent };
